import defaultZIndex from '@mui/material/styles/zIndex'

const zIndex = {
  ...defaultZIndex,
  // overrides values go here
}

export default zIndex
